

// $(document).ready(function () {


//   let ingredientSwiper;

//   $('.ingredient-accordion__toggle').on('click', function () {

//     let $this = $(this);
//     let $accordion = $this.closest('.ingredient-accordion');
//     let $content = $accordion.find('.ingredient-accordion__content');

//     // toggle content
//     $content.stop(true, true).slideToggle(300);

//     // toggle active class
//     $accordion.toggleClass('active');

//     // update aria
//     let expanded = $this.attr('aria-expanded') === 'true';
//     $this.attr('aria-expanded', !expanded);

//     // INIT SWIPER ONLY ONCE
//     setTimeout(function () {

//       if (!ingredientSwiper) {

//         ingredientSwiper = new Swiper('.ingredientSwiper', {
//           slidesPerView: 1,
//           spaceBetween: 20,

//           pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//           },

//           navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//           },

//           breakpoints: {
//             768: {
//               slidesPerView: 2,
//             },

//             1024: {
//               slidesPerView: 3,
//             }
//           }
//         });

//       } else {
//         ingredientSwiper.update();
//       }

//     }, 500);

//   });



// });
$(document).ready(function () {

  let ingredientSwiper;
  function initIngredientSwiper() {
    if (!ingredientSwiper) {
      ingredientSwiper = new Swiper('.ingredientSwiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        observer: true,
        observeParents: true,
        watchOverflow: false,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.swiper-button-next_',
          prevEl: '.swiper-button-prev_',
        },

        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1025: {
            slidesPerView: 2,
          }
        }
      });
    } else {
      ingredientSwiper.update();
      ingredientSwiper.navigation.update();
    }
  }

  $('.ingredient-accordion__toggle').on('click', function () {

    const $this = $(this);
    const $accordion = $this.closest('.ingredient-accordion');
    const $content = $accordion.find('.ingredient-accordion__content');

    $accordion.toggleClass('active');

    const expanded = $this.attr('aria-expanded') === 'true';
    $this.attr('aria-expanded', !expanded);

    $content.stop(true, true).slideToggle(300, function () {

      if (!ingredientSwiper) {
        initIngredientSwiper();

      } else {

        ingredientSwiper.update();
        ingredientSwiper.navigation.update();
        ingredientSwiper.autoplay.start();

      }

    });

  });
  $('.ingredient-accordion').addClass('active');
  $('.ingredient-accordion__toggle').attr('aria-expanded','true');
  $('.ingredient-accordion__content').css('display','block');
  setTimeout(() => {
    initIngredientSwiper();
  }, 300);
  setTimeout(() => {
    $('.product__accordion .dt-details').removeAttr('open');
  }, 100);
  
 

//   document.addEventListener('DOMContentLoaded', function () {

//   if (typeof Swiper !== 'undefined') {

//     document.querySelectorAll('[class*="results-swiper-"]')
//       .forEach(slider => {

//         new Swiper(slider, {

//           direction: 'vertical',
//           slidesPerView: 1,
//           loop: true,

//           autoplay: {
//             delay: 3000
//           }

//         });

//       });

//   }

//   // Open Modal
//   document.querySelectorAll('.js-results-modal-trigger')
//     .forEach(button => {

//       button.addEventListener('click', function () {

//         const modalId = this.dataset.modal;

//         document.getElementById(modalId)
//           .classList.add('active');

//       });

//     });

//   // Close Modal
//   document.querySelectorAll(
//     '.results-modal__close, .results-modal__overlay'
//   ).forEach(el => {

//       el.addEventListener('click', function () {

//         this.closest('.results-modal')
//           .classList.remove('active');

//       });

//   });

// });
$('.faq-section').each(function () {

    let hasContent = false;

    $(this).find('.accordion').each(function () {

      const titleText = $(this).find('.accordion__title').text().trim();

      // Hide accordion if h4 is empty
      if (titleText === '') {
        $(this).hide();
      } else {
        hasContent = true;
      }

    });

    // Hide entire faq section if no valid accordion exists
    if (!hasContent) {
      $(this).hide();
    } else {
      $(this).show();
    }

  });

setTimeout(function(){
   if ($(window).width() < 1025) {
   
    $('.ingredient-accordion').insertAfter('.product__payment');

  }
},1000);
 
});